import React from "react";
import { Box, Typography, Container, Chip, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import uiImg from "images/itservice/v2/system-dev.avif";
import devImg from "images/itservice/v2/ses-dev.jpg";
import aiImg from "images/itservice/v2/ai.png";
import backendImg from "images/itservice/v2/backend.png";
import wordpressImg from "images/itservice/v2/wordpress.jpg";
import appImg from "images/itservice/v2/app.jpg";
import BgTitle from "components/title/BgTitle";
export default ({ headingText = "Our IT Services" }) => {
  const { t } = useTranslation();

  const services = [
    {
      imageSrc: devImg,
      category: t("services.systemDesign.category"),
      title: t("services.systemDesign.title"),
      description: t("services.systemDesign.description"),
      featured: true,
    },
    {
      imageSrc: uiImg,
      category: t("services.frontendDevelopment.category"),
      title: t("services.frontendDevelopment.title"),
      description: t("services.frontendDevelopment.description"),
      featured: true,
    },
    {
      imageSrc: backendImg,
      category: t("services.backendDevelopment.category"),
      title: t("services.backendDevelopment.title"),
      description: t("services.backendDevelopment.description"),
      featured: true,
    },
    {
      imageSrc: appImg,
      category: t("services.mobileAppDevelopment.category"),
      title: t("services.mobileAppDevelopment.title"),
      description: t("services.mobileAppDevelopment.description"),
      featured: true,
    },
    {
      imageSrc: aiImg,
      category: t("services.aiSolutions.category"),
      title: t("services.aiSolutions.title"),
      description: t("services.aiSolutions.description"),
      featured: true,
    },
    {
      imageSrc: wordpressImg,
      category: t("services.wordpressDevelopment.category"),
      title: t("services.wordpressDevelopment.title"),
      description: t("services.wordpressDevelopment.description"),
      featured: true,
    },
  ];
  return (
    <Box sx={{ pb: 4, bgcolor: "#f8fafc" }}>
      <Container>
        {/* Header Section */}
        <Box
          sx={{
            mb: 2,
          }}
        >
          <Typography
            sx={{ fontSize: "0.8rem", fontWeight: 600 }}
            variant="subtitle1"
          >
            {t("services.headerTitle")}
          </Typography>
          <Box
            sx={{
              p: 1,
              borderLeft: "2px solid",
              borderColor: "primary.main",
              bgcolor: "#f5f5f5",
              mt: 1,
            }}
          >
            <Typography
              sx={{ fontSize: "0.7rem", fontWeight: 400 }}
              variant="subtitle1"
            >
              {t("services.headerSubtitle")}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            py: 3,
            position: "sticky",
            top: 0,
            bgcolor: "#f8fafc",
            zIndex: 10,
          }}
        >
          <BgTitle isCenter={true} text={t(headingText)} />
        </Box>

        {/* Services Grid */}
        <Grid container spacing={2}>
          {services.map((service, index) => (
            <Grid item xs={6} key={index}>
              <Box
                sx={{
                  bgcolor: "white",
                  borderRadius: 3,
                  overflow: "hidden",
                  border: "1px solid",
                  borderColor: "divider",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Header with Background Image */}
                <Box
                  sx={{
                    position: "relative",
                    height: 120,
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundImage: `url(${service.imageSrc})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      filter: "brightness(0.7)",
                    },
                  }}
                >
                  {/* Overlay Content */}
                  <Box
                    sx={{
                      position: "relative",
                      height: "100%",
                      p: 2,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Chip
                      label={service.category}
                      size="small"
                      sx={{
                        mb: 1,
                        height: 20,
                        bgcolor: "#f9f9f9",
                        color: "primary.main",
                        fontWeight: 670,
                        fontSize: "0.50rem",
                        width: "fit-content",
                        border: "1px solid gray",
                      }}
                    />
                  </Box>
                </Box>

                {/* Description Section */}
                <Box sx={{ p: 1, flex: 1, bgcolor: "white" }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.6rem",
                      color: "text.secondary",
                      lineHeight: 1.5,
                      display: "-webkit-box",
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {service.description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
